import * as Icons from '@ant-design/icons';
import { IDocument } from 'interfaces/documentation/document';
import { DocumentViewer } from './DocumentViewer';

interface DocumentItemImageProps {
  document: IDocument;
}

export const DocumentItemImage = ({ document }: DocumentItemImageProps) => {
  return (
    <DocumentViewer document={document}>
      <div className="w-full">
        <div
          className="rounded-md overflow-hidden cursor-pointer border border-gray-300"
          style={{ width: '120px' }}
        >
          <div className="flex items-center justify-center h-20 w-full text-3xl px-4 py-8">
            <Icons.FileSearchOutlined className="text-gray-400 drop-shadow-md" />
          </div>
        </div>
        <div className="text-xs text-gray-500 p-2 whitespace-nowrap overflow-hidden text-ellipsis w-full">
          {document.file_name}
        </div>
      </div>
    </DocumentViewer>
  );
};
